export function HijackingUd() {
    const courses = [
        { title: "Unity Ud - Introduction to HTML Web Development", link: "https://www.udemy.com/course/intro-to-html-web-development/?couponCode=ST7MT110524" },
        { title: "HTML and CSS for Beginners - Build a Website & Launch ONLINE", link: "https://www.udemy.com/course/html-and-css-for-beginners-crash-course-learn-fast-easy/?couponCode=ST7MT110524" },
        { title: "Learn HTML and CSS in 7 Days | Web Developer Bootcamp", link: "https://www.udemy.com/course/learn-html-and-css-in-7-days-web-developer-bootcamp/?couponCode=ST7MT110524" },
        { title: "Learn HTML: Course For Beginners", link: "https://www.udemy.com/course/html-course-for-beginners/?couponCode=ST7MT110524" },
        { title: "HTML5: HTML Authoring Certification Course", link: "https://www.udemy.com/course/html5-authoring-certification/?couponCode=ST7MT110524" }
    ];

    return (
        <>
            <h1 className="html_ud_heading">
                These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 5</strong> recommended Udemy links that you can refer to with certifications
            </h1>

            <h4 className="des_ud_html">
                1. Dive Into The Main Concepts <br />
                2. Animation Explanations with real-world Examples <br />
                3. Important with Note Clarification.
            </h4>

            {/* Render courses dynamically */}
            {courses.map((course, index) => (
                <div className="container_html_ud_links" key={index}>
                    <p className="vid">
                        {index + 1}. {course.title}
                        <button
                            style={{
                                marginLeft: '200px',
                                padding: '7px',
                                background: 'black',
                                color: 'white',
                                borderRadius: '8px'
                            }}
                            onClick={() => window.open(course.link, "_blank")}
                        >
                            Click Me
                        </button>
                    </p>
                </div>
            ))}
        </>
    );
}

export default HijackingUd;
